(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bestsellers-row"] && !Shopify.designMode) return;
  try {
    
  class BestsellersRowComponent extends HTMLElement {
    connectedCallback() {
      this.setup();
    }

    setup() {
      this.tablist = this.querySelector('[role="tablist"]');
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
      this.viewAllLink = document.querySelector(`#BestsellersViewAll-${this.dataset.sectionId}`);
      this._scrollRaf = null;

      if (this._handleTabClick) {
        this.tablist?.removeEventListener('click', this._handleTabClick);
      }

      this._handleTabClick = (event) => {
        const tab = event.target.closest('[role="tab"]');
        if (!tab || !this.tablist?.contains(tab)) return;
        event.preventDefault();
        this.selectTab(tab);
      };

      this.tablist?.addEventListener('click', this._handleTabClick);

      if (this._handleTabKeydown) {
        this.tablist?.removeEventListener('keydown', this._handleTabKeydown);
      }

      this._handleTabKeydown = (event) => this.onTabKeydown(event);
      this.tablist?.addEventListener('keydown', this._handleTabKeydown);

      this.panels.forEach((panel) => this.initCarousel(panel));

      const activeTab = this.tabs.find((tab) => tab.classList.contains('is-active'));
      if (activeTab) {
        this.syncViewAllLink(activeTab);
      }

      if (!this._resizeObserver) {
        this._resizeObserver = new ResizeObserver(() => {
          this.panels.forEach((panel) => {
            if (panel.classList.contains('is-active')) this.updateDots(panel);
          });
        });
        this._resizeObserver.observe(this);
      }
    }

    disconnectedCallback() {
      this.tablist?.removeEventListener('click', this._handleTabClick);
      this.tablist?.removeEventListener('keydown', this._handleTabKeydown);
      this._resizeObserver?.disconnect();
      this._resizeObserver = null;
    }

    findPanel(panelId) {
      return this.panels.find((panel) => panel.getAttribute('data-panel') === panelId);
    }

    initCarousel(panel) {
      const track = panel.querySelector('[data-track]');
      const dotsContainer = panel.querySelector('[data-dots]');
      if (!track || !dotsContainer || track.dataset.carouselInit) return;

      track.dataset.carouselInit = 'true';

      track.addEventListener(
        'scroll',
        () => {
          if (this._scrollingProgrammatically) return;
          cancelAnimationFrame(this._scrollRaf);
          this._scrollRaf = requestAnimationFrame(() => this.updateDots(panel));
        },
        { passive: true }
      );

      dotsContainer.addEventListener('click', (event) => {
        const dot = event.target.closest('[data-dot-index]');
        if (!dot) return;
        this.scrollToIndex(panel, Number(dot.dataset.dotIndex));
      });

      this.updateDots(panel);
    }

    getCarouselMetrics(panel) {
      const track = panel.querySelector('[data-track]');
      if (!track) return null;

      const cards = track.querySelectorAll('.bestseller-card');
      if (!cards.length) return null;

      const gap = parseFloat(getComputedStyle(track).gap || 0);
      const cardWidth = cards[0].offsetWidth;
      const scrollStep = cardWidth + gap;
      const visibleCount = Math.max(1, Math.floor((track.clientWidth + gap) / scrollStep));
      const dotCount = Math.max(1, cards.length - visibleCount + 1);

      return { track, scrollStep, dotCount };
    }

    scrollToIndex(panel, index) {
      const metrics = this.getCarouselMetrics(panel);
      if (!metrics) return;

      const { track, scrollStep, dotCount } = metrics;
      const targetIndex = Math.min(dotCount - 1, Math.max(0, index));

      this._scrollingProgrammatically = true;
      track.scrollTo({
        left: targetIndex * scrollStep,
        behavior: 'smooth',
      });

      window.setTimeout(() => {
        this._scrollingProgrammatically = false;
        this.updateDots(panel);
      }, 350);
    }

    selectTab(tab) {
      const panelId = tab.getAttribute('data-tab');
      const targetPanel = this.findPanel(panelId);
      if (!targetPanel) return;

      this.tabs.forEach((item) => {
        const isActive = item === tab;
        item.classList.toggle('is-active', isActive);
        item.setAttribute('aria-selected', isActive ? 'true' : 'false');
        item.tabIndex = isActive ? 0 : -1;
      });

      this.panels.forEach((panel) => {
        const isActive = panel === targetPanel;
        panel.classList.toggle('is-active', isActive);
        panel.setAttribute('aria-hidden', isActive ? 'false' : 'true');

        if (isActive) {
          const track = panel.querySelector('[data-track]');
          if (track) track.scrollLeft = 0;
          this.updateDots(panel);
        }
      });

      this.syncViewAllLink(tab);

      const viewport = this.querySelector('.bestsellers-row__tabs-viewport');
      if (viewport) {
        const tabLeft = tab.offsetLeft;
        const tabWidth = tab.offsetWidth;
        const viewportWidth = viewport.clientWidth;
        const targetScroll = tabLeft - viewportWidth / 2 + tabWidth / 2;
        viewport.scrollTo({
          left: Math.max(0, targetScroll),
          behavior: 'smooth',
        });
      }
    }

    syncViewAllLink(tab) {
      if (this.viewAllLink && tab.dataset.collectionUrl) {
        this.viewAllLink.href = tab.dataset.collectionUrl;
      }
    }

    onTabKeydown(event) {
      const supportedKeys = ['ArrowLeft', 'ArrowRight', 'Home', 'End'];
      if (!supportedKeys.includes(event.key)) return;

      const currentIndex = this.tabs.indexOf(document.activeElement);
      if (currentIndex === -1) return;

      event.preventDefault();

      let nextIndex = currentIndex;
      if (event.key === 'ArrowLeft') {
        nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
      } else if (event.key === 'ArrowRight') {
        nextIndex = (currentIndex + 1) % this.tabs.length;
      } else if (event.key === 'Home') {
        nextIndex = 0;
      } else if (event.key === 'End') {
        nextIndex = this.tabs.length - 1;
      }

      const nextTab = this.tabs[nextIndex];
      this.selectTab(nextTab);
      nextTab.focus();
    }

    updateDots(panel) {
      const dotsContainer = panel.querySelector('[data-dots]');
      const metrics = this.getCarouselMetrics(panel);
      if (!dotsContainer || !metrics) return;

      const { track, scrollStep, dotCount } = metrics;
      const activeIndex = Math.min(
        dotCount - 1,
        Math.max(0, Math.round(track.scrollLeft / scrollStep))
      );

      dotsContainer.hidden = dotCount <= 1;

      if (dotsContainer.children.length !== dotCount) {
        dotsContainer.innerHTML = '';
        for (let i = 0; i < dotCount; i++) {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'bestsellers-row__dot';
          dot.dataset.dotIndex = String(i);
          dot.setAttribute('aria-label', `Show products ${i + 1} of ${dotCount}`);
          dotsContainer.appendChild(dot);
        }
      }

      Array.from(dotsContainer.children).forEach((dot, index) => {
        const isActive = index === activeIndex;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-current', isActive ? 'true' : 'false');
      });
    }
  }

  if (!customElements.get('bestsellers-row-component')) {
    customElements.define('bestsellers-row-component', BestsellersRowComponent);
  }

  document.addEventListener('shopify:section:load', (event) => {
    if (!(event.target instanceof HTMLElement)) return;
    event.target.querySelectorAll('bestsellers-row-component').forEach((component) => {
      if (typeof component.setup === 'function') {
        component.setup();
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["neeloos-reviews"] && !Shopify.designMode) return;
  try {
    
  class NeeloosReviewsCarousel extends HTMLElement {
    constructor() {
      super();
      this.currentIndex = 0;
      this.isPaused = false;
      this.cardsPerViewDesktop = parseInt(this.dataset.cardsDesktop, 10) || 3;
      this.cardsPerViewTablet = parseInt(this.dataset.cardsTablet, 10) || 2;
      this.autoScrollEnabled = this.dataset.autoScroll === 'true';
      this.autoScrollSpeed = (parseInt(this.dataset.autoScrollSpeed, 10) || 5) * 1000;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      this.prevButton = this.querySelector('[data-prev]');
      this.nextButton = this.querySelector('[data-next]');
      this.dotsContainer = this.querySelector('[data-dots]');
      this.cards = Array.from(this.track?.children || []);

      if (this.cards.length === 0) return;

      this.updateCardsPerView();
      this.createDots();
      this.bindEvents();
      this.updateCarousel();
      this.startAutoplay();

      this.resizeObserver = new ResizeObserver(() => {
        this.updateCardsPerView();
        this.createDots();
        this.updateCarousel();
      });
      this.resizeObserver.observe(this);

      this.reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.onReducedMotionChange = (event) => {
        this.reducedMotion = event.matches;
        if (this.reducedMotion) {
          this.stopAutoplay();
        } else {
          this.startAutoplay();
        }
      };
      this.reducedMotionQuery.addEventListener('change', this.onReducedMotionChange);
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
      this.stopAutoplay();
      this.reducedMotionQuery?.removeEventListener('change', this.onReducedMotionChange);
    }

    get isMobilePeek() {
      return window.innerWidth <= 749;
    }

    updateCardsPerView() {
      if (this.isMobilePeek) {
        this.activeCardsPerView = 2;
        this.scrollStep = 1;
      } else if (window.innerWidth <= 989) {
        this.activeCardsPerView = this.cardsPerViewTablet;
        this.scrollStep = 1;
      } else {
        this.activeCardsPerView = this.cardsPerViewDesktop;
        this.scrollStep = 1;
      }

      const maxIndex = this.getMaxIndex();
      if (this.currentIndex > maxIndex) {
        this.currentIndex = maxIndex;
      }
    }

    getMaxIndex() {
      if (this.isMobilePeek) {
        return Math.max(0, this.cards.length - 2);
      }
      return Math.max(0, this.cards.length - this.activeCardsPerView);
    }

    getTotalDots() {
      return Math.max(1, this.getMaxIndex() + 1);
    }

    createDots() {
      if (!this.dotsContainer) return;

      this.dotsContainer.innerHTML = '';
      const totalDots = this.getTotalDots();

      for (let i = 0; i < totalDots; i++) {
        const dot = document.createElement('button');
        dot.className = 'neeloos-reviews__dot';
        dot.type = 'button';
        dot.setAttribute('role', 'tab');
        dot.setAttribute('aria-label', `Go to review slide ${i + 1}`);
        dot.setAttribute('aria-selected', i === this.currentIndex ? 'true' : 'false');
        dot.addEventListener('click', () => {
          this.goToIndex(i);
        });
        this.dotsContainer.appendChild(dot);
      }
    }

    goToIndex(index) {
      this.currentIndex = Math.min(Math.max(index, 0), this.getMaxIndex());
      this.updateCarousel();
      this.restartAutoplay();
    }

    prev() {
      if (this.currentIndex > 0) {
        this.currentIndex--;
      } else if (this.autoScrollEnabled) {
        this.currentIndex = this.getMaxIndex();
      }
      this.updateCarousel();
      this.restartAutoplay();
    }

    next() {
      const maxIndex = this.getMaxIndex();
      if (this.currentIndex < maxIndex) {
        this.currentIndex++;
      } else if (this.autoScrollEnabled) {
        this.currentIndex = 0;
      }
      this.updateCarousel();
      this.restartAutoplay();
    }

    bindEvents() {
      this.prevButton?.addEventListener('click', () => this.prev());
      this.nextButton?.addEventListener('click', () => this.next());

      let startX = 0;
      let currentX = 0;

      this.track?.addEventListener('touchstart', (event) => {
        startX = event.touches[0].clientX;
        this.pauseAutoplay();
      }, { passive: true });

      this.track?.addEventListener('touchmove', (event) => {
        currentX = event.touches[0].clientX;
      }, { passive: true });

      this.track?.addEventListener('touchend', () => {
        const diff = startX - currentX;
        if (Math.abs(diff) > 50) {
          if (diff > 0) this.next();
          else this.prev();
        }
        this.resumeAutoplay();
      });

      this.addEventListener('mouseenter', () => this.pauseAutoplay());
      this.addEventListener('mouseleave', () => this.resumeAutoplay());

      document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
          this.pauseAutoplay();
        } else {
          this.resumeAutoplay();
        }
      });
    }

    startAutoplay() {
      if (!this.autoScrollEnabled || this.reducedMotion) return;
      this.stopAutoplay();
      this.autoplayTimer = setInterval(() => {
        if (this.isPaused) return;
        this.next();
      }, this.autoScrollSpeed);
    }

    stopAutoplay() {
      if (this.autoplayTimer) {
        clearInterval(this.autoplayTimer);
        this.autoplayTimer = null;
      }
    }

    pauseAutoplay() {
      this.isPaused = true;
    }

    resumeAutoplay() {
      this.isPaused = false;
    }

    restartAutoplay() {
      this.stopAutoplay();
      this.startAutoplay();
    }

    updateCarousel() {
      const card = this.cards[0];
      if (!card || !this.track) return;

      const cardWidth = card.offsetWidth;
      const gap = parseInt(getComputedStyle(this.track).gap, 10) || 0;
      const offset = -(this.currentIndex * (cardWidth + gap));

      this.track.style.transform = `translateX(${offset}px)`;

      const maxIndex = this.getMaxIndex();

      if (this.prevButton) {
        this.prevButton.disabled = !this.autoScrollEnabled && this.currentIndex === 0;
      }
      if (this.nextButton) {
        this.nextButton.disabled = !this.autoScrollEnabled && this.currentIndex >= maxIndex;
      }

      this.dotsContainer?.querySelectorAll('.neeloos-reviews__dot').forEach((dot, index) => {
        dot.setAttribute('aria-selected', index === this.currentIndex ? 'true' : 'false');
      });
    }
  }

  if (!customElements.get('neeloos-reviews-carousel')) {
    customElements.define('neeloos-reviews-carousel', NeeloosReviewsCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["neeloos-video"] && !Shopify.designMode) return;
  try {
    
  class NeeloosVideoCarousel extends HTMLElement {
    constructor() {
      super();
      this.activeIndex = 0;
      this.isUserPaused = false;
      this.isCarouselSuspended = false;
      this.autoplayTimer = null;
      this.autoplayLoopId = 0;
      this.scrollAnimationId = null;
      this.scrollRaf = null;
      this.scrollingProgrammatically = false;
      this.autoplayEnabled = this.dataset.autoplay === 'true';
      this.autoplaySpeed = (parseInt(this.dataset.autoplaySpeed, 10) || 5) * 1000;
      this.slideDuration = parseInt(this.dataset.slideDuration, 10) || 700;
      this.mobileAspectMode = this.dataset.mobileAspect || 'auto';
      this.videoAutoplayEnabled = this.dataset.videoAutoplay === 'true';
      this.defaultMuted = this.dataset.videoMuted !== 'false';
      this.showMuteButton = this.dataset.showMuteButton !== 'false';
      this.videoLoop = this.dataset.videoLoop === 'true';
      this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      this.dotsContainer = this.querySelector('[data-dots]');
      this.cards = Array.from(this.track?.querySelectorAll('.neeloos-video__card') || []);

      if (!this.track || this.cards.length === 0) return;

      this.activeIndex = this.getIndexFromScroll();
      this.readSettings();

      this.initInlinePlayers();
      this.initVideoAutoplayObserver();
      this.initModal();
      this.bindEvents();
      this.refresh();

      requestAnimationFrame(() => {
        requestAnimationFrame(() => this.refresh());
      });

      this.resizeObserver = new ResizeObserver(() => {
        window.clearTimeout(this._refreshDebounce);
        this._refreshDebounce = window.setTimeout(() => this.refresh(), 200);
      });
      this.resizeObserver.observe(this);

      this.reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      this._handleReducedMotionChange = () => {
        this.prefersReducedMotion = this.reducedMotionQuery.matches;
        this.refresh();
      };
      this.reducedMotionQuery.addEventListener('change', this._handleReducedMotionChange);

      this._handleResize = () => {
        window.clearTimeout(this._resizeDebounce);
        this._resizeDebounce = window.setTimeout(() => this.refresh(), 150);
      };
      window.addEventListener('resize', this._handleResize);
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
      this.videoObserver?.disconnect();
      this.stopAutoplay();
      this.cancelScrollAnimation();
      window.clearTimeout(this._refreshDebounce);
      window.clearTimeout(this._resizeDebounce);
      if (this._resumeTimer) clearTimeout(this._resumeTimer);
      this.reducedMotionQuery?.removeEventListener('change', this._handleReducedMotionChange);
      window.removeEventListener('resize', this._handleResize);
    }

    readSettings() {
      this.autoplayEnabled = this.dataset.autoplay === 'true';
      this.autoplaySpeed = (parseInt(this.dataset.autoplaySpeed, 10) || 5) * 1000;
      this.slideDuration = parseInt(this.dataset.slideDuration, 10) || 700;
      this.mobileAspectMode = this.dataset.mobileAspect || 'auto';
      this.videoAutoplayEnabled = this.dataset.videoAutoplay === 'true';
      this.defaultMuted = this.dataset.videoMuted !== 'false';
      this.showMuteButton = this.dataset.showMuteButton !== 'false';
      this.videoLoop = this.dataset.videoLoop === 'true';
      this.desktopPopupEnabled = this.dataset.desktopPopup === 'true';
      this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    isDesktopViewport() {
      return window.innerWidth >= 750;
    }

    useDesktopPopup() {
      return this.desktopPopupEnabled && this.isDesktopViewport();
    }

    isMobileCarousel() {
      return window.innerWidth <= 749 && this.dataset.mobileLayout === 'row-scroll';
    }

    shouldDisableVideoAutoplayOnMobile() {
      return this.isMobileCarousel() && this.autoplayEnabled;
    }

    refresh() {
      this.readSettings();
      this.cards = Array.from(this.track?.querySelectorAll('.neeloos-video__card') || []);

      if (!this.isMobileCarousel()) {
        this.dotsContainer.innerHTML = '';
        this.stopAutoplay();
        return;
      }

      this.activeIndex = this.getIndexFromScroll();
      this.createDots();
      this.updateDots();

      if (!this.hasPlayingVideo()) {
        this.isCarouselSuspended = false;
      }

      if (!this.isUserPaused && !this.isCarouselSuspended) {
        this.startAutoplay();
      }
    }

    easeInOutCubic(progress) {
      return progress < 0.5
        ? 4 * progress * progress * progress
        : 1 - Math.pow(-2 * progress + 2, 3) / 2;
    }

    getCardScrollLeft(index) {
      const card = this.cards[index];
      if (!card || !this.track) return 0;

      const trackWidth = this.track.clientWidth;
      const cardWidth = card.offsetWidth;
      const maxScroll = Math.max(0, this.track.scrollWidth - trackWidth);
      const cardStart = card.offsetLeft;
      const centered = cardStart - (trackWidth - cardWidth) / 2;

      return Math.min(maxScroll, Math.max(0, centered));
    }

    cancelScrollAnimation() {
      if (this.scrollAnimationId) {
        cancelAnimationFrame(this.scrollAnimationId);
        this.scrollAnimationId = null;
      }
      this.track?.classList.remove('is-scrolling');
      this.scrollingProgrammatically = false;
    }

    animateScrollTo(targetLeft, duration = this.slideDuration) {
      if (!this.track) return Promise.resolve();

      this.cancelScrollAnimation();

      if (this.prefersReducedMotion || duration <= 0) {
        this.track.scrollLeft = targetLeft;
        this.scrollingProgrammatically = false;
        return Promise.resolve();
      }

      const startLeft = this.track.scrollLeft;
      const distance = targetLeft - startLeft;

      if (Math.abs(distance) < 1) {
        this.track.scrollLeft = targetLeft;
        return Promise.resolve();
      }

      this.scrollingProgrammatically = true;
      this.track.classList.add('is-scrolling');
      const startTime = performance.now();

      return new Promise((resolve) => {
        const step = (now) => {
          const elapsed = now - startTime;
          const progress = Math.min(elapsed / duration, 1);
          this.track.scrollLeft = startLeft + distance * this.easeInOutCubic(progress);

          if (progress < 1) {
            this.scrollAnimationId = requestAnimationFrame(step);
            return;
          }

          this.track.scrollLeft = targetLeft;
          this.scrollAnimationId = null;
          this.track.classList.remove('is-scrolling');
          this.scrollingProgrammatically = false;
          resolve();
        };

        this.scrollAnimationId = requestAnimationFrame(step);
      });
    }

    createDots() {
      if (!this.dotsContainer) return;

      this.dotsContainer.innerHTML = '';

      this.cards.forEach((_, index) => {
        const dot = document.createElement('button');
        dot.className = 'neeloos-video__dot';
        dot.type = 'button';
        dot.setAttribute('role', 'tab');
        dot.dataset.dotIndex = String(index);
        dot.setAttribute('aria-label', `Go to video ${index + 1}`);
        dot.setAttribute('aria-selected', index === this.activeIndex ? 'true' : 'false');
        dot.addEventListener('click', () => this.scrollToIndex(index));
        this.dotsContainer.appendChild(dot);
      });
    }

    bindEvents() {
      this.track.addEventListener(
        'scroll',
        () => {
          if (this.scrollingProgrammatically) return;
          cancelAnimationFrame(this.scrollRaf);
          this.scrollRaf = requestAnimationFrame(() => {
            this.activeIndex = this.getIndexFromScroll();
            this.updateDots();
          });
        },
        { passive: true }
      );

      let dragStartX = null;
      let dragPaused = false;

      const resetDrag = () => {
        dragStartX = null;
        dragPaused = false;
      };

      this.track.addEventListener('pointerdown', (event) => {
        if (event.target.closest('[data-play-button], [data-mute-button]')) return;
        dragStartX = event.clientX;
        dragPaused = false;
      });

      this.track.addEventListener(
        'pointermove',
        (event) => {
          if (dragStartX === null || dragPaused) return;
          if (Math.abs(event.clientX - dragStartX) > 12) {
            dragPaused = true;
            this.pauseCarouselForUser();
          }
        },
        { passive: true }
      );

      this.track.addEventListener('pointerup', () => {
        if (dragPaused) this.scheduleUserResume();
        resetDrag();
      });
      this.track.addEventListener('pointercancel', resetDrag);
      this.track.addEventListener('lostpointercapture', resetDrag);
    }

    getIndexFromScroll() {
      if (!this.track || this.cards.length === 0) return 0;

      const scrollLeft = this.track.scrollLeft;
      let closestIndex = 0;
      let closestDistance = Infinity;

      this.cards.forEach((card, index) => {
        const distance = Math.abs(this.getCardScrollLeft(index) - scrollLeft);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });

      return closestIndex;
    }

    async scrollToIndex(index, duration = this.slideDuration, options = {}) {
      const { fromAutoplay = false } = options;
      const card = this.cards[index];
      if (!card || !this.track) return;

      const previousIndex = this.activeIndex;
      const targetLeft = this.getCardScrollLeft(index);
      const isWrap =
        index === 0 &&
        previousIndex === this.cards.length - 1 &&
        previousIndex !== index;

      this.activeIndex = index;
      this.updateDots();

      if (isWrap) {
        this.cancelScrollAnimation();
        this.track.scrollLeft = targetLeft;
        return;
      }

      await this.animateScrollTo(targetLeft, duration);
      this.activeIndex = this.getIndexFromScroll();
      this.updateDots();

      if (!fromAutoplay) {
        window.setTimeout(() => {
          if (!this.hasPlayingVideo()) {
            this.resumeCarouselAutoplay();
          }
        }, 150);
      }
    }

    updateDots() {
      this.dotsContainer?.querySelectorAll('.neeloos-video__dot').forEach((dot, index) => {
        dot.setAttribute('aria-selected', index === this.activeIndex ? 'true' : 'false');
      });
    }

    waitAutoplayDelay(ms, loopId) {
      return new Promise((resolve) => {
        this._delayResolve = (completed) => {
          this._delayResolve = null;
          resolve(completed && loopId === this.autoplayLoopId);
        };
        this.autoplayTimer = window.setTimeout(() => {
          this.autoplayTimer = null;
          this._delayResolve?.(true);
        }, ms);
      });
    }

    cancelAutoplayDelay() {
      if (this.autoplayTimer) {
        clearTimeout(this.autoplayTimer);
        this.autoplayTimer = null;
      }
      this._delayResolve?.(false);
    }

    pauseAllVideosForCarousel() {
      this.mediaItems?.forEach((item) => {
        const thumb = item.querySelector('.neeloos-video__thumb');
        const video = item.querySelector('video');
        const muteButton = item.querySelector('[data-mute-button]');
        const embedFrame = item.querySelector('.neeloos-video__player--embed');
        const durationEl = item.querySelector('[data-duration]');

        this.setVideoPlayingState(thumb, muteButton, video, false);

        if (video && !video.paused) {
          video.pause();
          if (durationEl && Number.isFinite(video.duration)) {
            durationEl.textContent = this.formatTime(video.duration);
          }
        }

        if (embedFrame?.src) {
          embedFrame.src = '';
          item.querySelector('[data-embed-wrap]')?.setAttribute('hidden', '');
        }
      });
    }

    startAutoplay() {
      this.stopAutoplay();
      if (!this.autoplayEnabled || !this.isMobileCarousel()) return;
      if (this.isUserPaused || this.isCarouselSuspended) return;
      if (this.cards.length < 2) return;

      const loopId = ++this.autoplayLoopId;

      const runAutoplay = async () => {
        while (
          loopId === this.autoplayLoopId &&
          this.autoplayEnabled &&
          this.isMobileCarousel() &&
          !this.isUserPaused &&
          !this.isCarouselSuspended
        ) {
          const holdTime = Math.max(1200, this.autoplaySpeed - this.slideDuration);
          const delayOk = await this.waitAutoplayDelay(holdTime, loopId);
          if (!delayOk) break;

          if (
            loopId !== this.autoplayLoopId ||
            this.isUserPaused ||
            this.isCarouselSuspended ||
            !this.isMobileCarousel()
          ) {
            break;
          }

          this._carouselAdvancing = true;
          this.isCarouselSuspended = false;
          this.pauseAllVideosForCarousel();

          const nextIndex = (this.activeIndex + 1) % this.cards.length;
          await this.scrollToIndex(nextIndex, this.slideDuration, { fromAutoplay: true });
          this._carouselAdvancing = false;
        }
      };

      runAutoplay();
    }

    stopAutoplay() {
      this.autoplayLoopId += 1;
      this.cancelAutoplayDelay();
    }

    suspendCarouselAutoplay() {
      this.isCarouselSuspended = true;
      this.stopAutoplay();
    }

    resumeCarouselAutoplay() {
      this.isCarouselSuspended = false;
      if (!this.isUserPaused) {
        this.startAutoplay();
      }
    }

    pauseCarouselForUser() {
      this.isUserPaused = true;
      this.stopAutoplay();
      this.cancelScrollAnimation();
    }

    resumeCarouselForUser() {
      this.isUserPaused = false;
      this.startAutoplay();
    }

    scheduleUserResume() {
      if (this._resumeTimer) clearTimeout(this._resumeTimer);
      this._resumeTimer = window.setTimeout(() => this.resumeCarouselForUser(), 2500);
    }

    formatTime(seconds) {
      if (!Number.isFinite(seconds) || seconds < 0) return '0:00';
      const total = Math.floor(seconds);
      const mins = Math.floor(total / 60);
      const secs = total % 60;
      return `${mins}:${String(secs).padStart(2, '0')}`;
    }

    applyMobileAspectRatio(thumb, card, video) {
      if (!thumb || window.innerWidth > 749) return;
      if (thumb.classList.contains('neeloos-video__thumb--ratio-9-16') || thumb.classList.contains('neeloos-video__thumb--ratio-4-3')) {
        return;
      }

      let ratio = '4-3';
      if (video && video.videoWidth && video.videoHeight) {
        ratio = video.videoHeight > video.videoWidth ? '9-16' : '4-3';
      } else if (this.mobileAspectMode === '9-16') {
        ratio = '9-16';
      }

      thumb.classList.remove('neeloos-video__thumb--ratio-auto');
      thumb.classList.add(`neeloos-video__thumb--ratio-${ratio}`);
      card?.classList.remove('neeloos-video__card--ratio-auto');
      card?.classList.add(`neeloos-video__card--ratio-${ratio}`);
    }

    updateMuteButton(muteButton, isMuted) {
      if (!muteButton) return;
      const mutedIcon = muteButton.querySelector('.neeloos-video__mute-icon--muted');
      const unmutedIcon = muteButton.querySelector('.neeloos-video__mute-icon--unmuted');

      muteButton.setAttribute('aria-pressed', isMuted ? 'true' : 'false');
      muteButton.setAttribute('aria-label', isMuted ? 'Unmute video' : 'Mute video');

      if (mutedIcon) mutedIcon.hidden = !isMuted;
      if (unmutedIcon) unmutedIcon.hidden = isMuted;
    }

    syncMuteButton(muteButton, video) {
      if (!muteButton || !video) return;
      this.updateMuteButton(muteButton, video.muted);
    }

    setVideoPlayingState(thumb, muteButton, video, isPlaying) {
      thumb?.classList.toggle('is-playing', isPlaying);
      if (this.showMuteButton && muteButton && video) {
        muteButton.hidden = !isPlaying;
      }
    }

    pauseOtherVideos(currentMedia) {
      this.mediaItems?.forEach((item) => {
        if (item === currentMedia) return;
        const otherThumb = item.querySelector('.neeloos-video__thumb');
        const otherVideo = item.querySelector('video');
        const otherFrame = item.querySelector('.neeloos-video__player--embed');
        const otherMute = item.querySelector('[data-mute-button]');
        this.setVideoPlayingState(otherThumb, otherMute, otherVideo, false);
        if (otherVideo) {
          otherVideo.pause();
          const otherDuration = item.querySelector('[data-duration]');
          if (otherDuration && Number.isFinite(otherVideo.duration)) {
            otherDuration.textContent = this.formatTime(otherVideo.duration);
          }
        }
        if (otherFrame) {
          otherFrame.src = '';
          item.querySelector('[data-embed-wrap]')?.setAttribute('hidden', '');
        }
      });

      if (!this.hasPlayingVideo()) {
        this.resumeCarouselAutoplay();
      }
    }

    hasPlayingVideo() {
      return (
        this.mediaItems?.some((item) => {
          const video = item.querySelector('video');
          return video && !video.paused && !video.ended;
        }) || false
      );
    }

    initVideoAutoplayObserver() {
      this.videoObserver?.disconnect();
      if (!this.videoAutoplayEnabled || this.prefersReducedMotion) return;

      this.videoObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            const media = entry.target;
            const video = media.querySelector('video');
            const thumb = media.querySelector('.neeloos-video__thumb');
            const muteButton = media.querySelector('[data-mute-button]');
            if (!video) return;

            if (this.shouldDisableVideoAutoplayOnMobile()) return;

            if (entry.isIntersecting && entry.intersectionRatio >= 0.55) {
              if (this.useDesktopPopup()) return;

              this.pauseOtherVideos(media);
              this.suspendCarouselAutoplay();
              if (media.dataset.userUnmuted !== 'true') {
                video.muted = this.defaultMuted;
                this.updateMuteButton(muteButton, video.muted);
              }
              video.loop = this.videoLoop;
              this.setVideoPlayingState(thumb, muteButton, video, true);
              video.play().catch(() => {
                this.setVideoPlayingState(thumb, muteButton, video, false);
              });
            } else if (!video.paused) {
              video.pause();
              if (!video.ended) {
                this.setVideoPlayingState(thumb, muteButton, video, false);
              }
              this.resumeCarouselAutoplay();
            }
          });
        },
        { threshold: [0, 0.55, 0.85] }
      );

      this.mediaItems?.forEach((media) => {
        if (media.querySelector('video')) {
          this.videoObserver.observe(media);
        }
      });
    }

    initModal() {
      this.modal = this.querySelector('[data-neeloos-video-modal]');
      this.modalBody = this.querySelector('[data-neeloos-video-modal-body]');
      this.modalClose = this.querySelector('[data-neeloos-video-close]');
      if (!this.modal || !this.modalBody) return;

      this.modalClose?.addEventListener('click', () => this.closeVideoModal());
      this.modal.addEventListener('click', (event) => {
        if (event.target === this.modal) this.closeVideoModal();
      });
      this.modal.addEventListener('close', () => this.clearVideoModal());
    }

    clearVideoModal() {
      if (!this.modalBody) return;
      this.modalBody.querySelectorAll('video').forEach((video) => {
        video.pause();
        video.removeAttribute('src');
        video.load();
      });
      this.modalBody.innerHTML = '';
    }

    closeVideoModal() {
      if (!this.modal?.open) return;
      this.modal.close();
      this.clearVideoModal();
      this.resumeCarouselAutoplay();
    }

    openVideoModal(media) {
      if (!this.modal || !this.modalBody) return;

      const kind = media.dataset.videoKind;
      const card = media.closest('.neeloos-video__card');
      const caption = card?.querySelector('.neeloos-video__caption')?.textContent?.trim() || 'Video';
      const isUnmuted = media.dataset.userUnmuted === 'true';
      const shouldMute = !isUnmuted && this.defaultMuted;

      this.pauseOtherVideos(media);
      this.suspendCarouselAutoplay();
      this.clearVideoModal();

      if (kind === 'youtube' && media.dataset.youtubeId) {
        const iframe = document.createElement('iframe');
        iframe.className = 'neeloos-video__modal-player';
        iframe.src = `https://www.youtube.com/embed/${media.dataset.youtubeId}?autoplay=1&playsinline=1&rel=0&mute=${shouldMute ? '1' : '0'}`;
        iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
        iframe.allowFullscreen = true;
        iframe.title = caption;
        this.modalBody.appendChild(iframe);
      } else if (kind === 'vimeo' && media.dataset.vimeoId) {
        const iframe = document.createElement('iframe');
        iframe.className = 'neeloos-video__modal-player';
        iframe.src = `https://player.vimeo.com/video/${media.dataset.vimeoId}?autoplay=1&muted=${shouldMute ? '1' : '0'}`;
        iframe.allow = 'autoplay; fullscreen; picture-in-picture';
        iframe.allowFullscreen = true;
        iframe.title = caption;
        this.modalBody.appendChild(iframe);
      } else if (kind === 'shopify') {
        const template = card?.querySelector('[data-neeloos-video-template]');
        if (!template) return;
        const clone = template.content.cloneNode(true);
        const modalVideo = clone.querySelector('video');
        if (modalVideo) {
          modalVideo.muted = shouldMute;
          modalVideo.autoplay = true;
          modalVideo.controls = true;
        }
        this.modalBody.appendChild(clone);
      } else if (media.dataset.videoUrl) {
        const modalVideo = document.createElement('video');
        modalVideo.className = 'neeloos-video__modal-player';
        modalVideo.src = media.dataset.videoUrl;
        modalVideo.controls = true;
        modalVideo.autoplay = true;
        modalVideo.playsInline = true;
        modalVideo.muted = shouldMute;
        this.modalBody.appendChild(modalVideo);
      } else {
        const sourceVideo = media.querySelector('video');
        if (!sourceVideo) return;
        const modalVideo = document.createElement('video');
        modalVideo.className = 'neeloos-video__modal-player';
        modalVideo.controls = true;
        modalVideo.autoplay = true;
        modalVideo.playsInline = true;
        modalVideo.muted = shouldMute;
        sourceVideo.querySelectorAll('source').forEach((source) => {
          const clonedSource = document.createElement('source');
          clonedSource.src = source.src;
          clonedSource.type = source.type;
          modalVideo.appendChild(clonedSource);
        });
        if (sourceVideo.currentSrc) {
          modalVideo.src = sourceVideo.currentSrc;
        }
        this.modalBody.appendChild(modalVideo);
      }

      if (typeof this.modal.showModal === 'function') {
        this.modal.showModal();
      }
    }

    initInlinePlayers() {
      this.mediaItems = Array.from(this.querySelectorAll('[data-neeloos-video-media]'));

      this.mediaItems.forEach((media) => {
        if (media.dataset.inlineInit === 'true') return;
        media.dataset.inlineInit = 'true';

        const thumb = media.querySelector('.neeloos-video__thumb');
        const card = media.closest('.neeloos-video__card');
        const playButton = media.querySelector('[data-play-button]');
        const muteButton = media.querySelector('[data-mute-button]');
        const durationEl = media.querySelector('[data-duration]');
        const kind = media.dataset.videoKind;
        const video = media.querySelector('video.neeloos-video__player') || media.querySelector('video');
        const embedWrap = media.querySelector('[data-embed-wrap]');
        const embedFrame = media.querySelector('.neeloos-video__player--embed');

        if (video && media.dataset.posterUrl) {
          video.setAttribute('poster', media.dataset.posterUrl);
        }

        if (video) {
          video.muted = this.defaultMuted;
          video.loop = this.videoLoop;
          this.syncMuteButton(muteButton, video);

          video.addEventListener('volumechange', () => {
            this.syncMuteButton(muteButton, video);
          });
        }

        const showDuration = (seconds) => {
          if (!durationEl || !Number.isFinite(seconds)) return;
          durationEl.textContent = this.formatTime(seconds);
          durationEl.hidden = false;
        };

        const updateCountdown = () => {
          if (!video || !durationEl) return;
          const remaining = Math.max(0, video.duration - video.currentTime);
          durationEl.textContent = this.formatTime(remaining);
        };

        const pauseOthers = (currentMedia) => {
          this.pauseOtherVideos(currentMedia);
        };

        const startPlaying = () => {
          if (this.useDesktopPopup()) {
            this.openVideoModal(media);
            return;
          }

          pauseOthers(media);
          this.suspendCarouselAutoplay();
          if (video && media.dataset.userUnmuted !== 'true') {
            video.muted = this.defaultMuted;
            this.updateMuteButton(muteButton, video.muted);
          }
          this.setVideoPlayingState(thumb, muteButton, video, true);

          if (kind === 'youtube' && embedWrap && embedFrame && media.dataset.youtubeId) {
            embedWrap.removeAttribute('hidden');
            const muteParam = this.defaultMuted && media.dataset.userUnmuted !== 'true' ? '1' : '0';
            embedFrame.src = `https://www.youtube.com/embed/${media.dataset.youtubeId}?autoplay=1&playsinline=1&rel=0&mute=${muteParam}`;
            return;
          }

          if (kind === 'vimeo' && embedWrap && embedFrame && media.dataset.vimeoId) {
            embedWrap.removeAttribute('hidden');
            const muteParam = this.defaultMuted && media.dataset.userUnmuted !== 'true' ? '1' : '0';
            embedFrame.src = `https://player.vimeo.com/video/${media.dataset.vimeoId}?autoplay=1&muted=${muteParam}`;
            return;
          }

          if (video) {
            video.play().catch(() => {
              this.setVideoPlayingState(thumb, muteButton, video, false);
              this.resumeCarouselAutoplay();
            });
          }
        };

        if (video) {
          video.addEventListener('loadedmetadata', () => {
            this.applyMobileAspectRatio(thumb, card, video);
            showDuration(video.duration);
          });

          video.addEventListener('loadeddata', () => {
            this.applyMobileAspectRatio(thumb, card, video);
            if (!video.getAttribute('poster') && video.paused) {
              video.currentTime = Math.min(0.1, video.duration || 0.1);
            }
          });

          video.addEventListener('timeupdate', updateCountdown);

          video.addEventListener('play', () => {
            this.setVideoPlayingState(thumb, muteButton, video, true);
            if (!this._carouselAdvancing) {
              this.suspendCarouselAutoplay();
            }
            pauseOthers(media);
          });

          video.addEventListener('pause', () => {
            if (video.ended) return;
            this.setVideoPlayingState(thumb, muteButton, video, false);
            if (Number.isFinite(video.duration)) {
              showDuration(video.duration);
            }
            this.resumeCarouselAutoplay();
          });

          video.addEventListener('ended', () => {
            if (!this.videoLoop) {
              this.setVideoPlayingState(thumb, muteButton, video, false);
            }
            video.currentTime = 0;
            if (!video.getAttribute('poster') && Number.isFinite(video.duration)) {
              video.currentTime = Math.min(0.1, video.duration);
            }
            if (Number.isFinite(video.duration)) {
              showDuration(video.duration);
            }
            if (!this.videoLoop) {
              this.resumeCarouselAutoplay();
            }
          });

          if (video.readyState >= 1) {
            showDuration(video.duration);
          }
        }

        playButton?.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          startPlaying();
        });

        muteButton?.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          if (!video) return;

          const willBeMuted = !video.muted;
          video.muted = willBeMuted;

          if (willBeMuted) {
            delete media.dataset.userUnmuted;
          } else {
            media.dataset.userUnmuted = 'true';
          }

          this.syncMuteButton(muteButton, video);
        });

        thumb?.addEventListener('click', (event) => {
          if (event.target.closest('[data-play-button], [data-mute-button]')) return;

          if (this.useDesktopPopup()) {
            startPlaying();
            return;
          }

          if (kind === 'youtube' || kind === 'vimeo') return;
          if (video?.paused) {
            startPlaying();
          } else if (video) {
            video.pause();
          }
        });

        if ((kind === 'youtube' || kind === 'vimeo') && durationEl) {
          durationEl.hidden = true;
        }
      });
    }
  }

  if (!customElements.get('neeloos-video-carousel')) {
    customElements.define('neeloos-video-carousel', NeeloosVideoCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews-carousel"] && !Shopify.designMode) return;
  try {
    
  class ReviewsCarouselComponent extends HTMLElement {
    constructor() {
      super();
      this.currentIndex = 0;
      this.itemsPerView = 3;
    }

    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      this.prevButton = this.querySelector('[data-prev]');
      this.nextButton = this.querySelector('[data-next]');
      this.dotsContainer = this.querySelector('[data-dots]');
      this.cards = Array.from(this.track.children);

      this.updateItemsPerView();
      this.createDots();
      this.updateCarousel();
      this.setupEventListeners();

      this.resizeObserver = new ResizeObserver(() => {
        this.updateItemsPerView();
        this.createDots();
        this.updateCarousel();
      });
      this.resizeObserver.observe(this);
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
    }

    updateItemsPerView() {
      const width = window.innerWidth;
      if (width <= 749) {
        this.itemsPerView = 1;
      } else if (width <= 989) {
        this.itemsPerView = 2;
      } else {
        this.itemsPerView = 3;
      }
    }

    createDots() {
      this.dotsContainer.innerHTML = '';
      const totalDots = Math.max(0, this.cards.length - this.itemsPerView + 1);

      for (let i = 0; i < totalDots; i++) {
        const dot = document.createElement('button');
        dot.className = 'reviews-carousel__dot';
        dot.setAttribute('type', 'button');
        dot.setAttribute('role', 'tab');
        dot.setAttribute('aria-label', `Go to review ${i + 1}`);
        dot.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
        
        dot.addEventListener('click', () => {
          this.currentIndex = i;
          this.updateCarousel();
        });
        
        this.dotsContainer.appendChild(dot);
      }
    }

    setupEventListeners() {
      this.prevButton.addEventListener('click', () => {
        if (this.currentIndex > 0) {
          this.currentIndex--;
          this.updateCarousel();
        }
      });

      this.nextButton.addEventListener('click', () => {
        const maxIndex = this.cards.length - this.itemsPerView;
        if (this.currentIndex < maxIndex) {
          this.currentIndex++;
          this.updateCarousel();
        }
      });
    }

    updateCarousel() {
      if (this.cards.length === 0) return;

      const cardWidth = this.cards[0].offsetWidth;
      const gap = parseInt(getComputedStyle(this.track).gap) || 0;
      const offset = -(this.currentIndex * (cardWidth + gap));

      this.track.style.transform = `translateX(${offset}px)`;

      const maxIndex = this.cards.length - this.itemsPerView;
      this.prevButton.disabled = this.currentIndex === 0;
      this.nextButton.disabled = this.currentIndex >= maxIndex;

      const dots = this.dotsContainer.querySelectorAll('.reviews-carousel__dot');
      dots.forEach((dot, index) => {
        dot.setAttribute('aria-selected', index === this.currentIndex ? 'true' : 'false');
      });
    }
  }

  if (!customElements.get('reviews-carousel-component')) {
    customElements.define('reviews-carousel-component', ReviewsCarouselComponent);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials-slider"] && !Shopify.designMode) return;
  try {
    
  class TestimonialsCarousel extends HTMLElement {
    constructor() {
      super();
      this.currentIndex = 0;
      this.cardsPerView = parseInt(this.dataset.cardsDesktop) || 3;
      this.cardsPerViewTablet = parseInt(this.dataset.cardsTablet) || 2;
    }

    connectedCallback() {
      this.track = this.querySelector('.testimonials-slider__track');
      this.prevButton = this.querySelector('[data-prev]');
      this.nextButton = this.querySelector('[data-next]');
      this.cards = this.querySelectorAll('.testimonials-slider__card');
      this.totalCards = this.cards.length;

      if (this.totalCards === 0) return;

      this.updateCardsPerView();
      this.setupEventListeners();
      this.updateButtons();

      window.addEventListener('resize', () => {
        this.updateCardsPerView();
        this.updateSlider();
      });
    }

    updateCardsPerView() {
      if (window.innerWidth <= 749) {
        this.activeCardsPerView = 1;
      } else if (window.innerWidth <= 989) {
        this.activeCardsPerView = this.cardsPerViewTablet;
      } else {
        this.activeCardsPerView = this.cardsPerView;
      }

      const maxIndex = Math.max(0, this.totalCards - this.activeCardsPerView);
      if (this.currentIndex > maxIndex) {
        this.currentIndex = maxIndex;
      }
    }

    setupEventListeners() {
      this.prevButton?.addEventListener('click', () => this.prev());
      this.nextButton?.addEventListener('click', () => this.next());

      let startX = 0;
      let currentX = 0;

      this.track.addEventListener('touchstart', (e) => {
        startX = e.touches[0].clientX;
      }, { passive: true });

      this.track.addEventListener('touchmove', (e) => {
        currentX = e.touches[0].clientX;
      }, { passive: true });

      this.track.addEventListener('touchend', () => {
        const diff = startX - currentX;
        if (Math.abs(diff) > 50) {
          if (diff > 0) this.next();
          else this.prev();
        }
      });
    }

    prev() {
      if (this.currentIndex > 0) {
        this.currentIndex--;
        this.updateSlider();
      }
    }

    next() {
      if (this.currentIndex < this.totalCards - this.activeCardsPerView) {
        this.currentIndex++;
        this.updateSlider();
      }
    }

    updateSlider() {
      const card = this.cards[0];
      if (!card) return;

      const cardWidth = card.offsetWidth;
      const gap = parseInt(getComputedStyle(this.track).gap) || 0;
      const offset = -(this.currentIndex * (cardWidth + gap));

      this.track.style.transform = `translateX(${offset}px)`;
      this.updateButtons();
    }

    updateButtons() {
      if (this.prevButton) {
        this.prevButton.disabled = this.currentIndex === 0;
      }
      if (this.nextButton) {
        this.nextButton.disabled = this.currentIndex >= this.totalCards - this.activeCardsPerView;
      }
    }
  }

  customElements.define('testimonials-carousel', TestimonialsCarousel);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ugc-gallery"] && !Shopify.designMode) return;
  try {
    
  class UgcCarousel extends HTMLElement {
    constructor() {
      super();
      this.currentIndex = 0;
      this.trackWrapper = this.querySelector('.ugc-gallery__track-wrapper');
      this.track = this.querySelector('.ugc-gallery__track');
      this.items = Array.from(this.querySelectorAll('.ugc-gallery__item'));
      this.originalItemCount = Math.floor(this.items.length / 2); // Half are duplicates
      this.prevButton = this.querySelector('.ugc-gallery__control--prev');
      this.nextButton = this.querySelector('.ugc-gallery__control--next');
      this.dotsContainer = this.querySelector('.ugc-gallery__dots');
      this.isTransitioning = false;
      
      this.init();
    }

    init() {
      if (this.items.length === 0) return;

      this.setupEventListeners();
      this.setupDots();
      this.updateCarousel();
      this.setupVideos();
      
      // Handle resize
      this.resizeObserver = new ResizeObserver(() => this.updateCarousel());
      this.resizeObserver.observe(this.trackWrapper);
    }

    setupEventListeners() {
      this.prevButton?.addEventListener('click', () => this.prev());
      this.nextButton?.addEventListener('click', () => this.next());

      // Touch events for mobile swipe
      let startX = 0;
      let currentX = 0;
      
      this.track.addEventListener('touchstart', (e) => {
        startX = e.touches[0].clientX;
      });

      this.track.addEventListener('touchmove', (e) => {
        currentX = e.touches[0].clientX;
      });

      this.track.addEventListener('touchend', () => {
        const diff = startX - currentX;
        if (Math.abs(diff) > 50) {
          if (diff > 0) this.next();
          else this.prev();
        }
      });
    }

    setupDots() {
      if (!this.dotsContainer) return;
      
      const totalDots = this.originalItemCount;
      
      for (let i = 0; i < totalDots; i++) {
        const dot = document.createElement('button');
        dot.className = 'ugc-gallery__dot';
        dot.setAttribute('aria-label', `Go to slide ${i + 1}`);
        
        dot.addEventListener('click', () => {
          this.currentIndex = i;
          this.updateCarousel();
        });
        
        this.dotsContainer.appendChild(dot);
      }
    }

    setupVideos() {
      const videoContainers = this.querySelectorAll('.ugc-gallery__video-container');
      
      videoContainers.forEach(container => {
        const video = container.querySelector('video');
        const youtubeIframe = container.querySelector('.ugc-gallery__video--youtube');
        const playButton = container.querySelector('.ugc-gallery__play-button');
        
        // Skip YouTube videos - they handle their own playback
        if (youtubeIframe) {
          container.classList.add('is-playing');
          return;
        }
        
        // Handle regular video elements
        if (!video || !playButton) return;

        playButton.addEventListener('click', () => {
          if (video.paused) {
            video.play();
            container.classList.add('is-playing');
          } else {
            video.pause();
            container.classList.remove('is-playing');
          }
        });

        video.addEventListener('click', () => {
          if (!video.paused) {
            video.pause();
            container.classList.remove('is-playing');
          }
        });

        video.addEventListener('ended', () => {
          // Video will loop, so keep playing state
          container.classList.add('is-playing');
        });
      });
      
      // Update videos when carousel changes - this will autoplay visible videos
      this.updateVideosVisibility();
    }

    updateVideosVisibility() {
      const visibleItems = this.getVisibleItems();
      const startIndex = this.currentIndex;
      const endIndex = Math.min(this.items.length, startIndex + visibleItems);
      
      this.items.forEach((item, index) => {
        const videoContainer = item.querySelector('.ugc-gallery__video-container');
        if (!videoContainer) return;
        
        const video = videoContainer.querySelector('video');
        const youtubeIframe = videoContainer.querySelector('.ugc-gallery__video--youtube');
        
        const isVisible = index >= startIndex && index < endIndex;
        
        // Handle YouTube videos (iframe)
        if (youtubeIframe) {
          if (isVisible) {
            videoContainer.classList.add('is-playing');
            // YouTube videos autoplay via URL parameters, no JS needed
          } else {
            // Pause YouTube video by reloading iframe without autoplay
            const currentSrc = youtubeIframe.src;
            if (currentSrc.includes('autoplay=1')) {
              youtubeIframe.src = currentSrc.replace('autoplay=1', 'autoplay=0');
            }
            videoContainer.classList.remove('is-playing');
          }
          return;
        }
        
        // Handle regular video elements
        if (!video) return;
        
        if (isVisible) {
          // Video is visible, try to play
          if (video.paused) {
            const playPromise = video.play();
            if (playPromise !== undefined) {
              playPromise.then(() => {
                videoContainer.classList.add('is-playing');
              }).catch(() => {
                // Autoplay prevented
                videoContainer.classList.remove('is-playing');
              });
            }
          }
        } else {
          // Video is not visible, pause it
          if (!video.paused) {
            video.pause();
            videoContainer.classList.remove('is-playing');
          }
        }
      });
    }

    getVisibleItems() {
      const width = this.trackWrapper.offsetWidth;
      if (width < 750) return 1;
      if (width < 990) return 2;
      return 3;
    }

    prev() {
      if (this.isTransitioning) return;
      this.currentIndex -= 1;
      
      // Handle infinite loop - if going before start, jump to end of duplicates
      if (this.currentIndex < 0) {
        this.currentIndex = this.originalItemCount + this.currentIndex;
      }
      
      this.updateCarousel();
    }

    next() {
      if (this.isTransitioning) return;
      this.currentIndex += 1;
      
      // Handle infinite loop - if going past end of originals, continue through duplicates
      // Reset will happen after transition completes
      this.updateCarousel();
    }

    updateCarousel() {
      if (this.isTransitioning) return;
      
      const itemWidth = this.items[0]?.offsetWidth || 0;
      const gap = parseInt(getComputedStyle(this.track).gap) || 0;
      const itemStep = itemWidth + gap;
      
      // Check if we need to reset (scrolled into duplicates)
      const needsReset = this.currentIndex >= this.originalItemCount;
      
      const offset = -(this.currentIndex * itemStep);
      
      this.isTransitioning = true;
      this.track.style.transition = 'transform 0.5s cubic-bezier(0.4, 0, 0.2, 1)';
      this.track.style.transform = `translateX(${offset}px)`;

      this.updateUI();
      
      setTimeout(() => {
        this.isTransitioning = false;
        
        // Reset seamlessly after animation completes
        if (needsReset) {
          // Calculate the equivalent position in originals
          const targetIndex = this.currentIndex - this.originalItemCount;
          const targetOffset = -(targetIndex * itemStep);
          
          // Reset to original position (visually identical, so no jump)
          this.currentIndex = targetIndex;
          this.track.style.transition = 'none';
          this.track.style.transform = `translateX(${targetOffset}px)`;
          // Force reflow
          this.track.offsetHeight;
          // Restore transition for next animation
          this.track.style.transition = 'transform 0.5s cubic-bezier(0.4, 0, 0.2, 1)';
        }
      }, 500);
    }

    updateUI() {
      // Buttons are always enabled for infinite scroll
      if (this.prevButton) this.prevButton.disabled = false;
      if (this.nextButton) this.nextButton.disabled = false;

      // Update dots based on original item count
      const dots = this.dotsContainer?.querySelectorAll('.ugc-gallery__dot');
      if (dots) {
        const normalizedIndex = ((this.currentIndex % this.originalItemCount) + this.originalItemCount) % this.originalItemCount;
        dots.forEach((dot, i) => {
          dot.classList.toggle('is-active', i === normalizedIndex);
        });
      }
      
      // Update video visibility/playback
      this.updateVideosVisibility();
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
    }
  }

  customElements.define('ugc-carousel', UgcCarousel);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["whatsapp-float"] && !Shopify.designMode) return;
  try {
    
  class WhatsAppFloat extends HTMLElement {
    connectedCallback() {
      this.avoidStickyAtc = this.dataset.avoidStickyAtc === 'true';
      this.stickyOffset = parseInt(this.dataset.stickyOffset, 10) || 0;
      this.hideOnOverlays = this.dataset.hideOnOverlays !== 'false';

      this.updateVisibility = this.updateVisibility.bind(this);
      this.updateStickyLift = this.updateStickyLift.bind(this);

      document.addEventListener('dialog:open', this.updateVisibility);
      document.addEventListener('dialog:close', this.updateVisibility);
      window.addEventListener('resize', this.updateStickyLift);

      this.observer = new MutationObserver(() => {
        this.updateVisibility();
        this.updateStickyLift();
      });

      this.observer.observe(document.documentElement, {
        attributes: true,
        attributeFilter: ['scroll-lock'],
      });

      this.dialogObserver = new MutationObserver(this.updateVisibility);
      this.dialogObserver.observe(document.body, {
        attributes: true,
        subtree: true,
        attributeFilter: ['open'],
      });

      this.stickyObserver = new MutationObserver(this.updateStickyLift);
      this.stickyObserver.observe(document.body, {
        attributes: true,
        subtree: true,
        attributeFilter: ['class'],
      });

      this.updateVisibility();
      this.updateStickyLift();
    }

    disconnectedCallback() {
      document.removeEventListener('dialog:open', this.updateVisibility);
      document.removeEventListener('dialog:close', this.updateVisibility);
      window.removeEventListener('resize', this.updateStickyLift);
      this.observer?.disconnect();
      this.dialogObserver?.disconnect();
      this.stickyObserver?.disconnect();
    }

    isOverlayOpen() {
      if (!this.hideOnOverlays) return false;

      if (document.documentElement.hasAttribute('scroll-lock')) {
        return true;
      }

      return Boolean(document.querySelector('dialog[open]'));
    }

    updateVisibility() {
      this.classList.toggle('is-hidden', this.isOverlayOpen());
    }

    updateStickyLift() {
      if (!this.avoidStickyAtc || this.stickyOffset <= 0) {
        this.style.setProperty('--whatsapp-lift', '0px');
        return;
      }

      const stickyAtc = document.querySelector('.sticky-atc.sticky-atc--active');
      const lift = stickyAtc ? `${this.stickyOffset}px` : '0px';
      this.style.setProperty('--whatsapp-lift', lift);
    }
  }

  if (!customElements.get('whatsapp-float')) {
    customElements.define('whatsapp-float', WhatsAppFloat);
  }

  } catch(e) { console.error(e); }
})();
})();
